export default __webpack_public_path__ + "static/blockchain-9e80866c826c77628712f39ab1d3a56d.png";